/**
 * Invisible Breadcrumb Schema for SEO
 * Helps Google understand page hierarchy without visual breadcrumbs
 */

interface BreadcrumbItem {
  name: string;
  path: string;
}

interface SEOBreadcrumbSchemaProps {
  items: BreadcrumbItem[];
}

export const SEOBreadcrumbSchema = ({ items }: SEOBreadcrumbSchemaProps) => {
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": `https://scholz-interim.de${item.path}`
    }))
  };

  return (
    <script 
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
    />
  );
};
